import * as React from 'react';

function SvgCloudSleetFill(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M2.375 13.5a.25.25 0 01.25.25v.57l.501-.287a.25.25 0 01.248.434l-.495.283.495.283a.25.25 0 11-.248.434l-.501-.286v.569a.25.25 0 11-.5 0v-.57l-.501.287a.25.25 0 11-.248-.434l.495-.283-.495-.283a.25.25 0 11.248-.434l.501.286v-.569a.25.25 0 01.25-.25zm1.849-2.447a.5.5 0 01.223.67l-.5 1a.5.5 0 01-.894-.447l.5-1a.5.5 0 01.67-.223zM6.375 13.5a.25.25 0 01.25.25v.57l.5-.287a.25.25 0 01.249.434l-.495.283.495.283a.25.25 0 11-.248.434l-.501-.286v.569a.25.25 0 11-.5 0v-.57l-.501.287a.25.25 0 11-.248-.434l.495-.283-.495-.283a.25.25 0 11.248-.434l.501.286v-.569a.25.25 0 01.25-.25zm1.849-2.447a.5.5 0 01.223.67l-.5 1a.5.5 0 01-.894-.447l.5-1a.5.5 0 01.67-.223zm2.151 2.447a.25.25 0 01.25.25v.57l.5-.287a.25.25 0 01.249.434l-.495.283.495.283a.25.25 0 11-.248.434l-.501-.286v.569a.25.25 0 01-.5 0v-.57l-.501.287a.25.25 0 11-.248-.434l.495-.283-.495-.283a.25.25 0 11.248-.434l.501.286v-.569a.25.25 0 01.25-.25zm1.849-2.447a.5.5 0 01.223.67l-.5 1a.5.5 0 11-.894-.447l.5-1a.5.5 0 01.67-.223zm1.181-7.026a5.001 5.001 0 00-9.499-1.004A3.5 3.5 0 103.5 10H13a3 3 0 00.405-5.973z' />
		</svg>
	);
}

export default SvgCloudSleetFill;
